var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64645 0.646447C6.84171 0.451184 7.15829 0.451184 7.35355 0.646447L9.35355 2.64645C9.54882 2.84171 9.54882 3.15829 9.35355 3.35355L3.85355 8.85355C3.75979 8.94732 3.63261 9 3.5 9H1.5C1.22386 9 1 8.77614 1 8.5V6.5C1 6.36739 1.05268 6.24021 1.14645 6.14645L6.64645 0.646447ZM2 6.70711V8H3.29289L8.29289 3L7 1.70711L2 6.70711Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 11C1 10.7239 1.22386 10.5 1.5 10.5H10.5C10.7761 10.5 11 10.7239 11 11C11 11.2761 10.7761 11.5 10.5 11.5H1.5C1.22386 11.5 1 11.2761 1 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fef693e092df867d3a22096b1debafb4.svg";
export { ForwardRef as ReactComponent };